import { FaPlay } from "react-icons/fa";

export default function GalleryItem({
    video,
    index,
    onEnter,
    onLeave,
    onClick,
    onPlay, // 👈 pass this from parent
    videoRef,
}) {
    const isVideo = /\.(mp4|mov|webm)$/i.test(video.media);

    const handlePlayClick = (e) => {
        e.stopPropagation(); // ✅ prevent parent click
        onPlay?.(index);
    };

    return (
        <div
            className="gallery-item"
            style={{ height: video.height }}
            onMouseEnter={() => onEnter(index)}
            onMouseLeave={() => onLeave(index)}
            onClick={() => onClick(index)}
        >
            {isVideo ? (
                <>
                    <video
                        ref={videoRef}
                        src={video.media}
                        poster={video.poster_image}
                        muted
                        loop
                        playsInline
                        preload="metadata"
                        className="video-box"
                    />

                    {/* ✅ Play icon for video */}
                    <div
                        className="video-icon-container-dil"
                        onClick={handlePlayClick}
                    >
                        <FaPlay className="video-icon" />
                    </div>
                </>
            ) : (
                <img
                    src={video.poster_image || "/fallback.jpg"}
                    className="video-box"
                    alt=""
                />
            )}
        </div>
    );
}